import { ApiOrder } from '../../../cart/models/cart-models';
import * as moment from 'moment';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../../base/reducers';
import chaining from '../../../core/helpers/chaining';
var SummaryPageComponent = /** @class */ (function () {
    function SummaryPageComponent(store) {
        this.store = store;
        this.fullWidthView$ = store
            .pipe(select(fromBase.isFullWidthViewEnabled));
    }
    Object.defineProperty(SummaryPageComponent.prototype, "deliveryDate", {
        get: function () {
            return moment(chaining(this, 'order.dlvDate')).format('L');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryPageComponent.prototype, "address", {
        get: function () {
            var _this = this;
            return this.addresses.find(function (address) { return address.code === chaining(_this, 'order.dlvAddress'); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryPageComponent.prototype, "currency", {
        get: function () {
            return this.order.currency;
        },
        enumerable: true,
        configurable: true
    });
    return SummaryPageComponent;
}());
export { SummaryPageComponent };
